import React, { useEffect, useState } from "react";
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, Input, FormGroup, Label, Col, Row, Form,
  Alert, FormFeedback,
} from "reactstrap";
import { useFeira } from "../Contexts/FeiraContext";
import { api } from "../config";
import InputMask from 'react-input-mask';
import SidebarEstandeRenovacaoDados from "./SidebarMapa/SidebarEstandeRenovacaoDados";

const ModalRenovacao = () => {
  const { 
    openModalRenovacao, 
    setOpenModalRenovacao, 
    openModalRenovacaoReserva,
    setOpenModalRenovacaoReserva,
    emailRenovacao, 
    selectedEstandeInfo,
    camposRenovacao,
    configuracao,
    data,
    termos,
    setTermos,
    formaPagamentoId,
    setFormaPagamentoId,
    condicaoPagamentoId,
    setCondicaoPagamentoId,
    contrato,
    setComercialId,
    comercialId,
    observacao,
    setObservacao,
    cnpjCi,
    setCNPJCi,
    nome,
    setNome,
    email,
    setEmail,
    telefone,
    setTelefone,
    handleConfirmarReserva,
    erroCampoVazio,
    endereco,
    setEndereco,
    estado,
    setEstado,
    cep,
    setCep,
    cidade,
    setCidade,
    pais,
    setPais,
    limparCampos,
    paises,
    isLoading,
    showModalConfirmado,
    setShowModalConfirmado,
    nomeFeira,
    setAcessoRenovacaoLiberado,
    exibirAviso,
    corPrincipal,
    corSecundaria,
    isMobile,
    setOpenMobile,
    whatsappPrincipal,
    mensagemPadrao,
    setOpenModalWhatsapp,
    openModalWhatsapp,
    recarregarEstandes,
  } = useFeira();
  
  const [openModalTermos, setOpenModalTermos] = useState(false);
  const [showModalInconsistencia, setShowModalInconsistencia] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const [emailDigitado, setEmailDigitado] = useState("");
  const [senha, setSenha] = useState("");
  const [emailValidado, setEmailValidado] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [validandoSenha, setValidandoSenha] = useState(false);
  
  const emailMascarado = emailRenovacao ? emailRenovacao.replace(/(.{2})(.*)(@.*)/, (_, a, b, c) => `${a}${"*".repeat(b.length)}${c}`) : "";
  
  const [dadosConfirmacao, setDadosConfirmacao] = useState({});
  const feiraDados = data?.retorno?.dados || {};
  const formasPagamento = feiraDados.formas_pagamento || [];
  const condicoesPagamento = feiraDados.condicoes_pagamento || [];
  const comerciais = selectedEstandeInfo?.comercial || [];

  const [showModalConfirmacao, setShowModalConfirmacao] = useState(false);
  const [showModalConfirmacaoReserva, setShowModalConfirmacaoReserva] = useState(false);

  const handleOpenTermos = () => {
    setOpenModalTermos(true);
  };
useEffect(() => {
  if (
    openModalRenovacao &&
    configuracao?.renovacao_com_senha === false &&
    selectedEstandeInfo?.expositor?.[0]
  ) {
    const expositor = selectedEstandeInfo.expositor[0];

    const initialData = {};
    if (configuracao?.obrigar_cpf_nome_renovacao) {
      initialData.cpf = "";
      initialData.nome = "";
    }

    camposRenovacao?.forEach((campo) => {
      initialData[campo.nome_campo] =
        expositor?.[campo.nome_campo] || "";
    });

    setDadosConfirmacao(initialData);
    setAcessoRenovacaoLiberado(true);
    setEmailDigitado("");
    setSenha("");
    setEmailValidado(false);
    setOpenModalRenovacao(false);
    setShowModalConfirmacao(true);
  }
}, [
  openModalRenovacao,
  configuracao,
  selectedEstandeInfo,
  camposRenovacao,
  setAcessoRenovacaoLiberado,
  setOpenModalRenovacao
]);

useEffect(() => {
  if (
    openModalRenovacaoReserva &&
    configuracao?.renovacao_com_senha === false &&
    selectedEstandeInfo?.expositor?.[0]
  ) {
    const expositor = selectedEstandeInfo.expositor[0];

    setNome(expositor.nome || "");
    setCNPJCi(expositor.cnpj_codigo_internacional || expositor.cnpj_cpf || "");
    setEmail(expositor.email_renovacao || expositor.email || "");
    setTelefone(expositor.telefone || "");
    setEndereco(expositor.endereco || "");
    setEstado(expositor.estado || "");
    setCep(expositor.cep || "");
    setCidade(expositor.cidade || "");
    setPais(expositor.pais || "");

    setAcessoRenovacaoLiberado(true);
    setEmailDigitado("");
    setSenha("");
    setEmailValidado(false);
    setOpenModalRenovacaoReserva(false);
    setShowModalConfirmacaoReserva(true);
  }
}, [
  openModalRenovacaoReserva,
  configuracao,
  selectedEstandeInfo,
  setAcessoRenovacaoLiberado,
  setOpenModalRenovacaoReserva,
  setNome,
  setCNPJCi,
  setEmail,
  setTelefone,
  setEndereco,
  setEstado,
  setCep,
  setCidade,
  setPais
]);

  // useEffect(() => {
  //   if (showModalConfirmacao && selectedEstandeInfo) {
  //     const initialData = {};
  //     if (configuracao.obrigar_cpf_nome_renovacao) {
  //       initialData.cpf = '';
  //       initialData.nome = '';
  //     }
  //     camposRenovacao.forEach(campo => {
  //       initialData[campo.nome_campo] = selectedEstandeInfo.expositor?.[0]?.[campo.nome_campo] || '';
  //     });
  //     setDadosConfirmacao(initialData);
  //   }
  // }, [showModalConfirmacao, selectedEstandeInfo, camposRenovacao, configuracao]);

  const handleValidarEmail = async () => {
    if (emailDigitado.toLowerCase().trim() !== emailRenovacao.toLowerCase().trim()) {
      exibirAviso("Atenção", "O e-mail informado não corresponde ao cadastrado.");
      return;
    }

    try {
      setEnviando(true);
      const response = await fetch(`${api.API_URL}/renovacao/enviarSenha`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          chave: "18266602-6085-4532-992d-7bc2750b19f4"
        },
        body: JSON.stringify({ 
            feira_id: selectedEstandeInfo?.expositor?.[0].feira_id, 
            expositor_id: selectedEstandeInfo.expositor?.[0].id, 
            email_renovacao: emailDigitado, 
            estande_id: selectedEstandeInfo.id,
            estande_nome: selectedEstandeInfo.nome,
            feira_nome: nomeFeira
        }),
      });

      if (!response.ok) {
        const erro = await response.json();
        throw new Error(erro.message || "Erro ao enviar dados");
      }
      exibirAviso("Aviso", "Senha enviada para seu e-mail.");
      setEmailValidado(true);
    } catch (err) {
      exibirAviso("Atenção", err.message || "Erro na requisição.");
    } finally {
      setEnviando(false);
    }
  };

  const validarCampos = () => {
    
    const newErrors = {};
    let isValid = true;
    if (!formaPagamentoId) { newErrors.formaPagamentoId = "Obrigatório"; isValid = false; }
    if (!condicaoPagamentoId) { newErrors.condicaoPagamentoId = "Obrigatório"; isValid = false; }
    if (!termos && configuracao.renovacao_com_senha == true) { newErrors.termos = "Aceite os termos"; isValid = false; }
    if (comerciais.length > 0 && !comercialId) { newErrors.comercialId = "Obrigatório"; isValid = false; }

    if (configuracao.obrigar_cpf_nome_renovacao) {
      const cpfSemMascara = dadosConfirmacao.cpf ? dadosConfirmacao.cpf.replace(/\D/g, '') : '';
      if (!dadosConfirmacao.cpf || cpfSemMascara.length !== 11 || !validarCPF(cpfSemMascara)) {
        newErrors.cpf = "CPF Inválido"; isValid = false;
      }
      if (!dadosConfirmacao.nome || dadosConfirmacao.nome.trim() === '') {
        newErrors.nome = "Nome Obrigatório"; isValid = false;
      }
    }
    
    setErrors(newErrors);
    return isValid;
  };

  function validarCPF(cpf) {
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    let soma = 0;
    for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
    let resto = 11 - (soma % 11);
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;
    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
    resto = 11 - (soma % 11);
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(10))) return false;
    return true;
  }

  const handleValidarSenha = async (renovando) => {
    try {
      setValidandoSenha(true);
      const response = await fetch(`${api.API_URL}/renovacao/validarSenha`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        chave: "18266602-6085-4532-992d-7bc2750b19f4",
        body: JSON.stringify({ 
          feira_id: selectedEstandeInfo?.expositor?.[0].feira_id, 
          expositor_id: selectedEstandeInfo.expositor?.[0].id, 
          estande_id: selectedEstandeInfo.id,
          senha_informada: senha 
        }),
      });

      const dataRes = await response.json();
      if (dataRes.data?.senha) {
        setAcessoRenovacaoLiberado(true);
        setEmailDigitado("");
        setSenha("");
        setEmailValidado(false);

        if (dataRes.data.bloqueio_estande || dataRes.data.bloqueio_expositor) {
          exibirAviso("Atenção", "Entre em contato com o comercial.");
          setShowModalInconsistencia(true);
          return;
        }

        if (renovando) {
          setShowModalConfirmacao(true);
          setOpenModalRenovacao(false);
        } else {
          setShowModalConfirmacaoReserva(true);
          setOpenModalRenovacaoReserva(false);
        }
      } else {
        exibirAviso("Atenção", "Senha inválida.");
      }
    } catch (err) {
      exibirAviso("Atenção", "Erro ao validar senha.");
    } finally {
      setValidandoSenha(false);
    }
  };

  const handleConfirmarRenovacao = async (e) => {
    e.preventDefault();
    if (!validarCampos()) return;
    setEnviando(true);
    try {
      const camposEditados = {};
      camposRenovacao.forEach(campo => {
        camposEditados[campo.nome_campo] = dadosConfirmacao[campo.nome_campo] !== undefined 
          ? dadosConfirmacao[campo.nome_campo] 
          : selectedEstandeInfo.expositor?.[0]?.[campo.nome_campo] || '';
      });

      const dadosParaEnvio = {
        feira_id: selectedEstandeInfo?.expositor?.[0].feira_id,
        forma_pagamento_id: formaPagamentoId,
        comercial_id: comercialId,
        condicao_pagamento_id: condicaoPagamentoId,
        expositor_id: selectedEstandeInfo.expositor?.[0].id,
        estande_id: selectedEstandeInfo.id,
        ...(configuracao.obrigar_cpf_nome_renovacao && {
          cpf: dadosConfirmacao.cpf,
          nome: dadosConfirmacao.nome
        }),
        campos: [camposEditados] 
      };

      const response = await fetch(`${api.API_URL}/renovacao/confirmar`, {
        method: "POST",
        headers: { "Content-Type": "application/json", chave: "18266602-6085-4532-992d-7bc2750b19f4" },
        body: JSON.stringify(dadosParaEnvio),
      });

      if (!response.ok) throw new Error("Erro ao confirmar renovação");
      setShowModalConfirmado(true);
      setTimeout(async () => {
        setShowModalConfirmado(false);
        setShowModalConfirmacao(false);
        await recarregarEstandes();
      }, 4000);
    } catch (err) {
      exibirAviso("Atenção", err.message);
    } finally {
      setEnviando(false);
    }
  };

  const handleChangeReserva = (e) => {
    const { name, value } = e.target;
    switch(name) {
      case 'nome': setNome(value); break;
      case 'pais': setPais(value); break;
      case 'cnpjCi': setCNPJCi(value); break;
      case 'email': setEmail(value); break;
      case 'telefone': setTelefone(value); break;
      case 'cep': setCep(value); break;
      case 'cidade': setCidade(value); break;
      case 'estado': setEstado(value); break;
      case 'endereco': setEndereco(value); break;
      case 'formaPagamentoId': setFormaPagamentoId(value); break;
      case 'condicaoPagamentoId': setCondicaoPagamentoId(value); break;
      case 'observacao': setObservacao(value); break;
      default: break;
    }
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: null }));
  };

  const handleConfirmarReservaComValidacao = (e) => {
    e.preventDefault();
    if (!validarCampos()) {
      
      exibirAviso("Atenção", "Preencha os campos obrigatórios.");
      return;
    }
    handleConfirmarReserva(e);
  };

  return (
    <>
      <Modal zIndex={5000} isOpen={openModalRenovacao && configuracao?.renovacao_com_senha !== false} centered>
        <ModalHeader toggle={() => setOpenModalRenovacao(false)}>Validação de Renovação</ModalHeader>
        <ModalBody>
          <p>Informe o e-mail usado para a renovação:</p>
          <p><strong>{emailMascarado}</strong></p>
          <FormGroup>
            <Label>E-mail:</Label>
            <Input type="email" value={emailDigitado} onChange={(e) => setEmailDigitado(e.target.value)} disabled={emailValidado} />
          </FormGroup>
          {emailValidado && (
            <FormGroup>
              <Label>Senha recebida:</Label>
              <div className="position-relative">
                <Input type={showPassword ? "text" : "password"} value={senha} onChange={(e) => setSenha(e.target.value)} />
                <button className="btn btn-link position-absolute end-0 top-0 shadow-none" onClick={() => setShowPassword(!showPassword)} type="button"><i className="ri-eye-fill"></i></button>
              </div>
            </FormGroup>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setOpenModalRenovacao(false)}>Cancelar</Button>
          {!emailValidado ? (
            <Button color="primary" onClick={handleValidarEmail} disabled={enviando}>{enviando ? "..." : "Enviar senha"}</Button>
          ) : (
            <Button color="success" onClick={() => handleValidarSenha(true)} disabled={validandoSenha}>{validandoSenha ? "..." : "Validar senha"}</Button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={openModalRenovacaoReserva && configuracao?.renovacao_com_senha !== false} centered>
        <ModalHeader toggle={() => setOpenModalRenovacaoReserva(false)}>Validação de Reserva</ModalHeader>
        <ModalBody>
          <p>Informe o e-mail usado para a renovação:</p>
          <p><strong>{emailMascarado}</strong></p>
          <FormGroup>
            <Label>E-mail:</Label>
            <Input type="email" value={emailDigitado} onChange={(e) => setEmailDigitado(e.target.value)} disabled={emailValidado} />
          </FormGroup>
          {emailValidado && (
            <FormGroup>
              <Label>Senha recebida:</Label>
              <div className="position-relative">
                <Input type={showPassword ? "text" : "password"} value={senha} onChange={(e) => setSenha(e.target.value)} />
                <button className="btn btn-link position-absolute end-0 top-0 shadow-none" onClick={() => setShowPassword(!showPassword)} type="button"><i className="ri-eye-fill"></i></button>
              </div>
            </FormGroup>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setOpenModalRenovacaoReserva(false)}>Cancelar</Button>
          {!emailValidado ? (
            <Button color="primary" onClick={handleValidarEmail} disabled={enviando}>{enviando ? "..." : "Enviar senha"}</Button>
          ) : (
            <Button color="success" onClick={() => handleValidarSenha(false)} disabled={validandoSenha}>{validandoSenha ? "..." : "Validar senha"}</Button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={showModalConfirmacao} size="lg" centered backdrop="static">
        <ModalHeader toggle={() => setShowModalConfirmacao(false)}>Confirmação de Renovação</ModalHeader>
        <ModalBody className="p-4">
          <Row>
            <Col md={5}>
              <SidebarEstandeRenovacaoDados
                selectedEstandeInfo={selectedEstandeInfo}
                corPrincipal={corPrincipal} corSecundaria={corSecundaria} isMobile={isMobile} setOpenMobile={setOpenMobile}
                whatsappPrincipal={whatsappPrincipal} nomeFeira={nomeFeira} mensagemPadrao={mensagemPadrao}
                openModalWhatsapp={openModalWhatsapp} setOpenModalWhatsapp={setOpenModalWhatsapp}
              />
            </Col>
            <Col md={7}>
              <Row>
                <Col lg={6}>
                  <FormGroup>
                    <Label>Forma de Pagamento*</Label>
                    <Input type="select" value={formaPagamentoId} onChange={(e) => setFormaPagamentoId(e.target.value)} invalid={!!errors.formaPagamentoId}>
                      <option value="">Selecione...</option>
                      {formasPagamento.map(i => <option key={i.id} value={i.id}>{i.nome}</option>)}
                    </Input>
                  </FormGroup>
                </Col>
                <Col lg={6}>
                  <FormGroup>
                    <Label>Cond. de Pagamento*</Label>
                    <Input type="select" value={condicaoPagamentoId} onChange={(e) => setCondicaoPagamentoId(e.target.value)} invalid={!!errors.condicaoPagamentoId}>
                      <option value="">Selecione...</option>
                      {condicoesPagamento.map(i => <option key={i.id} value={i.id}>{i.nome}</option>)}
                    </Input>
                  </FormGroup>
                </Col>
                {comerciais.length > 0 && (
                  <Col lg={12}>
                    <FormGroup>
                      <Label>Comercial*</Label>
                      <Input type="select" value={comercialId} onChange={(e) => setComercialId(e.target.value)} invalid={!!errors.comercialId}>
                        <option value="">Selecione...</option>
                        {comerciais.map(i => <option key={i.id} value={i.id}>{i.nome}</option>)}
                      </Input>
                    </FormGroup>
                  </Col>
                )}
              </Row>
              {camposRenovacao.length > 0 && (
                <>
                <h5 className="mb-2 mt-2 pt-2 border-top">Dados do Expositor</h5>
                <Row className="g-1">
                  {camposRenovacao?.map((campo) => (
                    <Col md={4} key={campo.id}>
                      <FormGroup>
                        <Label className="small">{campo.nome_campo.replace(/_/g, ' ')}</Label>
                        <Input type="text" value={dadosConfirmacao[campo.nome_campo] || ''} onChange={(e) => setDadosConfirmacao({...dadosConfirmacao, [campo.nome_campo]: e.target.value})} />
                      </FormGroup>
                    </Col>
                  ))}
                </Row>
                </>
              )}
              {configuracao.renovacao_com_senha === true && (
                <FormGroup className="mt-2 pt-2 border-top">
                  <div className="form-check">
                    <Input type="checkbox" checked={termos} onChange={(e) => setTermos(e.target.checked)} invalid={!!errors.termos} />
                    <Label className="form-check-label">Aceito os <span className="text-primary" onClick={handleOpenTermos}>Termos e Condições*</span></Label>
                  </div>
                </FormGroup>
              )}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={() => setShowModalConfirmacao(false)}>Cancelar</Button>
          <Button color="success" onClick={handleConfirmarRenovacao} disabled={enviando}>{enviando ? "Enviando..." : "Confirmar"}</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={showModalConfirmacaoReserva} size="lg" centered>
        <ModalHeader toggle={() => setShowModalConfirmacaoReserva(false)}>Reservar Estande</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleConfirmarReservaComValidacao}>
             <Row>
                 <Col md={5}><SidebarEstandeRenovacaoDados selectedEstandeInfo={selectedEstandeInfo} corPrincipal={corPrincipal}/></Col>
                 <Col md={7}>
                    <Row className="g-2">
                        <Col lg={12}><Label>Nome*</Label><Input name="nome" value={nome} onChange={handleChangeReserva} invalid={!!errors.nome}/></Col>
                        <Col lg={6}><Label>País*</Label>
                            <Input name="pais" type="select" onChange={handleChangeReserva} value={pais} invalid={!!errors.pais}>
                                <option value="">Selecione...</option>
                                {paises.map(p => <option key={p.sigla} value={p.sigla}>{p.nome}</option>)}
                            </Input>
                        </Col>
                        <Col lg={6}><Label>CNPJ/Código*</Label><Input name="cnpjCi" value={cnpjCi} onChange={handleChangeReserva} invalid={!!errors.cnpjCi}/></Col>
                        <Col lg={6}><Label>E-mail*</Label><Input name="email" value={email} onChange={handleChangeReserva}/></Col>
                        <Col lg={6}><Label>Telefone*</Label><InputMask mask="(99) 99999-9999" className="form-control" name="telefone" value={telefone} onChange={handleChangeReserva}/></Col>
                        <Col lg={6}><Label>Forma Pagto*</Label>
                             <Input name="formaPagamentoId" type="select" value={formaPagamentoId} onChange={handleChangeReserva} invalid={!!errors.formaPagamentoId}>
                                <option value="">Selecione...</option>
                                {formasPagamento.map(i => <option key={i.id} value={i.id}>{i.nome}</option>)}
                             </Input>
                        </Col>
                        <Col lg={6}><Label>Cond. Pagto*</Label>
                             <Input name="condicaoPagamentoId" type="select" value={condicaoPagamentoId} onChange={handleChangeReserva} invalid={!!errors.condicaoPagamentoId}>
                                <option value="">Selecione...</option>
                                {condicoesPagamento.map(i => <option key={i.id} value={i.id}>{i.nome}</option>)}
                             </Input>
                        </Col>
                        {comerciais.length > 0 && (
                        <Col lg={12}>
                          <FormGroup>
                            <Label>Comercial*</Label>
                            <Input type="select" value={comercialId} onChange={(e) => setComercialId(e.target.value)} invalid={!!errors.comercialId}>
                              <option value="">Selecione...</option>
                              {comerciais.map(i => <option key={i.id} value={i.id}>{i.nome}</option>)}
                            </Input>
                          </FormGroup>
                        </Col>
                      )}
                        
                        {configuracao.renovacao_com_senha === true && (
                          <FormGroup className="mt-2 pt-2 border-top">
                            <div className="form-check">
                              <Input type="checkbox" checked={termos} onChange={(e) => setTermos(e.target.checked)}/>
                              <Label className="form-check-label">Aceito os <span className="text-primary" onClick={handleOpenTermos}>Termos e Condições*</span></Label>
                            </div>
                          </FormGroup>
                        )}
                    </Row>
                 </Col>
             </Row>
             <div className="mt-3 text-end">
                <Button color="success" type="submit" disabled={isLoading}>{isLoading ? "Enviando..." : "Confirmar"}</Button>
             </div>
          </Form>
        </ModalBody>
      </Modal>

      <Modal isOpen={showModalConfirmado} centered backdrop="static">
        <ModalBody className="text-center p-4">
          <h4>Solicitação enviada com sucesso!</h4>
        </ModalBody>
      </Modal>
      
      <Modal isOpen={openModalTermos} toggle={() => setOpenModalTermos(false)} size="lg">
        <ModalHeader toggle={() => setOpenModalTermos(false)}>Termos e Condições</ModalHeader>
        <ModalBody style={{ overflowY: "auto" }}>
          <div dangerouslySetInnerHTML={{ __html: contrato || "" }} />
        </ModalBody>
      </Modal>
    </>
  );
};

export default ModalRenovacao;